import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    success: {
        color: theme.palette.success.main
    },
    buttonPerception:{
        padding: '0px'
    }
}));